import _styled from "@emotion/styled/base";
import React from "react";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var TickIcon = function TickIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.414 19.687 9.023-9.023-2.296-2.297-6.727 6.672-3.5-3.555-2.352 2.35 5.852 5.853Zm11.484 4.21C21.164 26.633 17.864 28 14 28c-3.865 0-7.164-1.368-9.899-4.102C1.367 21.164 0 17.865 0 14c0-3.865 1.367-7.165 4.101-9.9C6.836 1.368 10.135 0 14 0c3.864 0 7.164 1.367 9.898 4.1C26.633 6.836 28 10.136 28 14s-1.367 7.164-4.102 9.898Z",
    fill: "#fff"
  }));
};
TickIcon.defaultProps = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export const Container = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yc3qie1"
} : {
  target: "e1yc3qie1",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSW1DIiwiZmlsZSI6InN0eWxlcy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIjtcblxuaW1wb3J0IFRpY2tJY29uIGZyb20gXCIuL2ljb24tdGljay5zdmdcIjtcblxuZXhwb3J0IGNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG5gO1xuXG5leHBvcnQgY29uc3QgU3R5bGVkVGlja0ljb24gPSBzdHlsZWQoVGlja0ljb24pYFxuICBmbGV4OiBub25lO1xuXG4gIGlubGluZS1zaXplOiAyOHB4O1xuICBibG9jay1zaXplOiAyOHB4O1xuICBtYXJnaW4taW5saW5lLWVuZDogMTZweDtcbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
export const StyledTickIcon = /*#__PURE__*/_styled(TickIcon, process.env.NODE_ENV === "production" ? {
  target: "e1yc3qie0"
} : {
  target: "e1yc3qie0",
  label: "StyledTickIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "dyx8jd",
  styles: "flex:none;inline-size:28px;block-size:28px;margin-inline-end:16px"
} : {
  name: "dyx8jd",
  styles: "flex:none;inline-size:28px;block-size:28px;margin-inline-end:16px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUThDIiwiZmlsZSI6InN0eWxlcy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIjtcblxuaW1wb3J0IFRpY2tJY29uIGZyb20gXCIuL2ljb24tdGljay5zdmdcIjtcblxuZXhwb3J0IGNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG5gO1xuXG5leHBvcnQgY29uc3QgU3R5bGVkVGlja0ljb24gPSBzdHlsZWQoVGlja0ljb24pYFxuICBmbGV4OiBub25lO1xuXG4gIGlubGluZS1zaXplOiAyOHB4O1xuICBibG9jay1zaXplOiAyOHB4O1xuICBtYXJnaW4taW5saW5lLWVuZDogMTZweDtcbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});